import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full h-full flex items-center" }
const _hoisted_2 = { class: "text-center px-8 space-y-10" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "space-y-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-primary-faded text-xl font-semibold" }, "Flytt samtalen til SMS"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-primary" }, " Vi fortsetter gjerne samtalen på SMS. Vi trenger bare å vite hvordan vi kan nå deg. ")
], -1)
const _hoisted_4 = { class: "space-y-4" }
const _hoisted_5 = { class: "space-y-1" }

import ActionButton from "@/features/shared/ActionButton.vue";
import { useGraphqlSdk } from "@/graphql/graphql-client";
import { ref } from "vue";
import { GChatPreChatSurveyFieldType, GConversationChannelItem } from "@/generated/graphql";
import emitter from "@/utils/mitt";
import preChatSurveyPersistence from "@/utils/preChatSurveyPersistence";
import visitorCountryPersistence from "@/utils/visitorCountryPersistence";


export default /*#__PURE__*/_defineComponent({
  __name: 'TransferConversationSms',
  props: {
  tenant: {
    type: String,
    required: true,
  },

  conversation: {
    type: String,
    required: true,
  },
},
  emits: ["close"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emits = __emit;

const address = ref();

const surveyState = preChatSurveyPersistence.getState();
const filledPhoneNumber =
  surveyState?.find(i => i.type === GChatPreChatSurveyFieldType.PhoneNumber)?.value ?? undefined;

if (filledPhoneNumber) {
  address.value = filledPhoneNumber;
} else {
  const persistence = visitorCountryPersistence.getState();

  if (persistence) {
    address.value = `+${persistence}`;
  }
}

const submitForm = () => {
  // Workarond pending FormKit 1.3.3 (https://github.com/formkit/formkit/issues/1057)
  const iframeDocument = (document.getElementById("sa-chat-widget-iframe") as HTMLIFrameElement)?.contentWindow
    ?.document;
  if (!iframeDocument) {
    throw new Error("Couldnt get iframe document");
  }

  const formElement = iframeDocument.getElementById("sms-form");
  if (formElement instanceof HTMLFormElement) {
    const event = new Event("submit", { cancelable: true, bubbles: true });
    formElement.dispatchEvent(event);
    return;
  }
};

async function transferConversation() {
  const sdk = useGraphqlSdk();
  try {
    await sdk.TransferConversation({
      input: {
        tenant: props.tenant,
        conversation: props.conversation,
        address: address.value,
        channel: GConversationChannelItem.Sms,
      },
    });

    emits("close");
  } catch (err) {
    console.warn(err);
    emitter.emit("error", "Det oppstod en feil");
  }
}

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_FormKit, {
            type: "form",
            id: "sms-form",
            "form-class": "px-4 space-y-3 sm:p-6",
            onSubmit: transferConversation,
            actions: false
          }, {
            default: _withCtx(({ state }) => [
              _createVNode(_component_FormKit, {
                type: "tel",
                ref: "input",
                name: "Telefonnummer",
                label: "Telefonnummer",
                modelValue: address.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((address).value = $event)),
                placeholder: "+479999999",
                class: "py-2 px-2 rounded-md w-full",
                validation: "required|phone"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_FormKit, { type: "submit" }, {
                input: _withCtx(() => [
                  _createVNode(ActionButton, {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (submitForm())),
                    loading: state.loading
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Flytt samtalen")
                    ]),
                    _: 2
                  }, 1032, ["loading"])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}
}

})